export default "__VITE_ASSET__BDFEPO7g__"